import { log } from "./logs";

const timingInfo = window.__bt_intrnl?.timings ?? {
  shouldLog: false,
};

const rlinkScriptLoadedTimestamp = Date.now();

const { shouldLog } = timingInfo;

export function logRlinkScriptLoaded() {
  const event = "timing.rlinkScriptLoaded";
  const meta: Record<string, object | string> = {
    timestamp: String(rlinkScriptLoadedTimestamp),
  };

  if (shouldLog) {
    log(event, meta);
  }
}
